import * as React from 'react';

import { classNames } from '@core/utils/functions/class-names';

type PriceSectionHeaderProps = {
    question: string;
    children: string | React.ReactElement | React.ReactFragment;
    className?: string;
};

const PriceSectionHeader = (props: PriceSectionHeaderProps) => {
    const { question, children, className } = props;

    return (
        <div className={classNames('flex flex-col justify-start items-start self-stretch gap-3', className)}>
            <h4 className="text-xl font-semibold text-left text-dark font-headline">{question}</h4>
            <p className="text-md text-left text-dark">
                <>{children}</>
            </p>
        </div>
    );
};

export default PriceSectionHeader;
